module.exports = __webpack_public_path__ + "img/cpp.50570a76.png";